
<div>
    <app-bar :title="collection.name"/>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <div class="pt-8 pb-12 px-8" style="width: 100%">
            <div class="pb-10">
                <v-btn
                    @click="edit"
                    class="sm mr-5"
                    color="primary"
                >{{ t('general_action_edit') }}
                </v-btn>
                <v-btn
                    class="sm mr-5"
                    color="primary"
                    outlined
                    @click.prevent="suspend(collection)"
                >
                    {{ collection.enabled ? t('general_action_suspend') : t('general_action_unsuspend') }}
                </v-btn>
                <confirm-modal
                    v-if="permitted('admin_workout_management')"
                    :title="t('general_title_confirm_action')"
                    @agree="hideWorkouts(collection)"
                >
                    <template #content>
                        <div class="text-center">{{ t('collection_warning_hide_workouts') }}</div>
                    </template>
                    <template #default="{ on, attrs }">
                        <v-btn
                            class="sm mr-5"
                            color="primary"
                            outlined
                            v-on="on"
                            v-bind="attrs"
                        >{{ t('collection_action_hide_workouts') }}</v-btn>
                    </template>
                </confirm-modal>
                <confirm-modal
                    :title="t('general_title_confirm_action')"
                    @agree="del(collection)"
                >
                    <template #content>
                        <div class="text-center">{{ t('collection_warning_delete') }}</div>
                    </template>
                    <template #default="{ on, attrs }">
                        <v-btn
                            class="sm"
                            color="orange"
                            outlined
                            v-on="on"
                            v-bind="attrs"
                        >{{ t('general_action_delete') }}</v-btn>
                    </template>
                </confirm-modal>
            </div>
            <div class="float-left mr-10" style="width: 394px; max-width: 394px">
                <img
                    v-if="collection.photoUrl"
                    :src="collection.photoUrl"
                    width="394"
                />
                <img
                    v-if="collection.headerPhotoUrl"
                    class="mt-4"
                    :src="collection.headerPhotoUrl"
                    width="394"
                />
                <div class="form-subtitle">{{ t('collection_label_description') }}:</div>
                <div class="form-subtitle-description" v-html="collection.description"></div>
                <template v-if="collection.author">
                    <div class="form-subtitle">{{ t('collection_label_author') }}:</div>
                    <div class="form-subtitle-description">{{ collection.author }}</div>
                </template>
                <template v-if="collection.authorPhotoUrl">
                    <div class="form-subtitle">{{ t('collection_label_author_photo') }}:</div>
                    <v-avatar size="92" class="mt-2">
                        <v-img :src="collection.authorPhotoUrl"></v-img>
                    </v-avatar>
                </template>
                <template v-if="collection.videoUrl">
                    <div class="form-subtitle">{{ t('collection_label_video_url') }}:</div>
                    <div class="form-subtitle-description">
                        <a :href="collection.videoUrl" target="_blank" rel="noopener">{{ collection.videoUrl }}</a>
                    </div>
                </template>
                <mux-playback-id-field
                    readonly
                    :value="collection.muxPlaybackId"
                    :label="t('collection_label_mux_playback_id')"
                ></mux-playback-id-field>

                <card-unit class="mt-6" :items="items()">
                    <template #title>{{ t('collection_label_id') }}: {{ collection.id }}</template>
                </card-unit>
            </div>
            <div class="float-left" style="max-width: calc(100% - 434px)">
                <card-collection
                    :meta="workoutsMeta"
                    :busy="workoutsBusy"
                    @updated="onWorkoutsPage"
                >
                    <template #data>
                        <thead>
                        <tr>
                            <th>{{ t('workout_label_id') }}</th>
                            <th>{{ t('workout_label_name') }}</th>
                            <th>{{ t('workout_label_stroke') }}</th>
                            <th>{{ t('collection_label_level') }}</th>
                            <th>{{ t('workout_label_duration') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="workouts.data.length === 0">
                            <td class="text-center" colspan="5">{{ t('general_text_no_data') }}</td>
                        </tr>
                        <tr v-for="workout in workouts.data">
                            <td class="titled">{{ workout.id }}</td>
                            <td class="titled">
                                <a
                                    :href="`/workouts/${workout.id}/view`"
                                    target="_blank"
                                >{{ workout.name || `#${workout.id}` }}</a>
                                <v-icon
                                    v-if="workout.libraryHidden"
                                    :title="t('workout_label_library_hidden')"
                                    small
                                >mdi-eye-off-outline</v-icon>
                            </td>
                            <td>{{ workout.stroke.name }}</td>
                            <td>{{ levelTitle(workout.level) }}</td>
                            <td>{{ time.format(workout.workoutTotalTime) }}</td>
                        </tr>
                        </tbody>
                    </template>
                </card-collection>
            </div>
        </div>
    </v-layout>
</div>
